import "core-js/modules/es.array.push.js";
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "container function"
};
const _hoisted_2 = {
  class: "handle-box"
};
const _hoisted_3 = ["data-id"];
const _hoisted_4 = {
  class: "param-opt"
};
const _hoisted_5 = {
  class: "param-opt"
};
const _hoisted_6 = {
  class: "param-line"
};
const _hoisted_7 = {
  class: "dialog-footer"
};
import { Delete, Plus } from "@element-plus/icons-vue";
import { onMounted, reactive, ref } from "vue";
import { httpGet, httpPost } from "@/utils/http";
import { ElMessage } from "element-plus";
import { arrayContains, copyObj } from "@/utils/libs";
export default {
  __name: 'Functions',
  setup(__props) {
    const showDialog = ref(false);
    const parentBorder = ref(true);
    const childBorder = ref(true);
    const tableData = ref([]);
    const item = ref({});
    const params = ref([]);
    const formRef = ref(null);
    const loading = ref(true);
    const title = ref("新增函数");
    const rules = reactive({
      name: [{
        required: true,
        message: '请输入函数名称',
        trigger: 'blur'
      }],
      label: [{
        required: true,
        message: '请输入函数标签',
        trigger: 'blur'
      }],
      description: [{
        required: true,
        message: '请输入函数功能描述',
        trigger: 'blur'
      }]
    });
    const paramsType = ref(["string", "number"]);
    onMounted(() => {
      fetch();
    });
    const fetch = () => {
      httpGet('/api/admin/function/list').then(res => {
        if (res.data) {
          tableData.value = res.data;
        }
        loading.value = false;
      }).catch(() => {
        ElMessage.error("获取数据失败");
      });
    };

    // 编辑
    const curIndex = ref(0);
    const rowEdit = function (index, row) {
      title.value = "编辑函数";
      curIndex.value = index;
      item.value = copyObj(row);
      // initialize parameters
      const props = item.value?.parameters?.properties;
      const required = item.value?.parameters?.required;
      const _params = [];
      for (let key in props) {
        _params.push({
          name: key,
          type: props[key].type,
          desc: props[key].description,
          required: arrayContains(required, key)
        });
      }
      params.value = _params;
      showDialog.value = true;
    };
    const addRow = function () {
      item.value = {
        enabled: true
      };
      params.value = [];
      showDialog.value = true;
    };
    const save = function () {
      formRef.value.validate(valid => {
        if (valid) {
          showDialog.value = false;
          const properties = {};
          const required = [];
          // process params
          for (let i = 0; i < params.value.length; i++) {
            properties[params.value[i].name] = {
              "type": params.value[i].type,
              "description": params.value[i].desc
            };
            if (params.value[i].required) {
              required.push(params.value[i].name);
            }
          }
          item.value.parameters = {
            type: "object",
            "properties": properties,
            required: required
          };
          httpPost('/api/admin/function/save', item.value).then(res => {
            ElMessage.success('操作成功');
            console.log(res.data);
            if (item.value.id > 0) {
              tableData.value[curIndex.value] = item.value;
            } else {
              tableData.value.push(res.data);
            }
          }).catch(e => {
            ElMessage.error('操作失败，' + e.message);
          });
        }
      });
    };
    const remove = function (row) {
      httpGet('/api/admin/function/remove?id=' + row.id).then(() => {
        ElMessage.success("删除成功！");
        fetch();
      }).catch(() => {
        ElMessage.error("删除失败！");
      });
    };
    const addParam = function () {
      if (!params.value) {
        item.value = [];
      }
      params.value.push({
        name: "",
        type: "string",
        desc: "",
        required: false
      });
    };
    const removeParam = function (index) {
      params.value.splice(index, 1);
    };
    const functionSet = (filed, row) => {
      httpPost('/api/admin/function/set', {
        id: row.id,
        filed: filed,
        value: row[filed]
      }).then(() => {
        ElMessage.success("操作成功！");
      }).catch(e => {
        ElMessage.error("操作失败：" + e.message);
      });
    };
    const generateToken = () => {
      httpGet('/api/admin/function/token').then(res => {
        ElMessage.success("生成 Token 成功");
        item.value.token = res.data;
      }).catch(() => {
        ElMessage.error("生成 Token 失败");
      });
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_popconfirm = _resolveComponent("el-popconfirm");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
        type: "primary",
        icon: _unref(Plus),
        onClick: addRow
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("新增")])),
        _: 1
      }, 8, ["icon"])]), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_table, {
          data: tableData.value,
          border: parentBorder.value,
          style: {
            "width": "100%"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "函数名称",
            prop: "name"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", {
              class: "sort",
              "data-id": scope.row.id
            }, _toDisplayString(scope.row.name), 9, _hoisted_3)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "函数别名",
            prop: "label"
          }), _createVNode(_component_el_table_column, {
            label: "功能描述",
            prop: "description"
          }), _createVNode(_component_el_table_column, {
            label: "启用状态"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_switch, {
              modelValue: scope.row.enabled,
              "onUpdate:modelValue": $event => scope.row.enabled = $event,
              onChange: $event => functionSet('enabled', scope.row)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            width: "150",
            align: "right"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_button, {
              size: "small",
              type: "primary",
              onClick: $event => rowEdit(scope.$index, scope.row)
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("编辑")])),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_el_popconfirm, {
              title: "确定要删除当前函数吗?",
              onConfirm: $event => remove(scope.row),
              width: 200
            }, {
              reference: _withCtx(() => [_createVNode(_component_el_button, {
                size: "small",
                type: "danger"
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("删除")])),
                _: 1
              })]),
              _: 2
            }, 1032, ["onConfirm"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data", "border"])]),
        _: 1
      }), _createVNode(_component_el_dialog, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => showDialog.value = $event),
        title: title.value,
        "close-on-click-modal": false,
        width: "50%"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_7, [_createVNode(_component_el_button, {
          onClick: _cache[6] || (_cache[6] = $event => showDialog.value = false)
        }, {
          default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: save
        }, {
          default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode("保存")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: item.value,
          "label-width": "120px",
          ref_key: "formRef",
          ref: formRef,
          "label-position": "left",
          rules: rules
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "函数名称：",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: item.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => item.value.name = $event),
              placeholder: "函数名称最好为英文",
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "函数标签：",
            prop: "label"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: item.value.label,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => item.value.label = $event),
              placeholder: "函数的中文名称",
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "功能描述：",
            prop: "description"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: item.value.description,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => item.value.description = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "函数参数：",
            prop: "parameters"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table, {
              data: params.value,
              border: childBorder.value,
              size: "small"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_table_column, {
                label: "参数名称",
                width: "120"
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_input, {
                  modelValue: scope.row.name,
                  "onUpdate:modelValue": $event => scope.row.name = $event,
                  autocomplete: "off"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "参数类型",
                width: "120"
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_select, {
                  modelValue: scope.row.type,
                  "onUpdate:modelValue": $event => scope.row.type = $event,
                  placeholder: "参数类型"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paramsType.value, pt => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      value: pt,
                      key: pt
                    }, {
                      default: _withCtx(() => [_createTextVNode(_toDisplayString(pt), 1)]),
                      _: 2
                    }, 1032, ["value"]);
                  }), 128))]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue"])]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "参数描述"
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_input, {
                  modelValue: scope.row.desc,
                  "onUpdate:modelValue": $event => scope.row.desc = $event,
                  autocomplete: "off"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "必填参数",
                width: "80"
              }, {
                default: _withCtx(scope => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_checkbox, {
                  modelValue: scope.row.required,
                  "onUpdate:modelValue": $event => scope.row.required = $event
                }, null, 8, ["modelValue", "onUpdate:modelValue"])])]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "操作",
                width: "80"
              }, {
                default: _withCtx(scope => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
                  type: "danger",
                  icon: _unref(Delete),
                  circle: "",
                  onClick: $event => removeParam(scope.$index),
                  size: "small"
                }, null, 8, ["icon", "onClick"])])]),
                _: 1
              })]),
              _: 1
            }, 8, ["data", "border"]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_button, {
              type: "primary",
              onClick: addParam,
              size: "small"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_unref(Plus))]),
                _: 1
              }), _cache[11] || (_cache[11] = _createTextVNode(" 增加参数 "))]),
              _: 1
            })])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "API 地址：",
            prop: "action"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: item.value.action,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => item.value.action = $event),
              autocomplete: "off",
              placeholder: "该函数实现的API地址，可以是第三方服务API"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "API Token：",
            prop: "token"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: item.value.token,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => item.value.token = $event),
              autocomplete: "off",
              placeholder: "API授权Token"
            }, {
              append: _withCtx(() => [_createVNode(_component_el_tooltip, {
                class: "box-item",
                effect: "dark",
                content: "只有本地服务才可以使用自动生成Token<br/>第三方服务请填写第三方服务API Token",
                placement: "top-end",
                "raw-content": ""
              }, {
                default: _withCtx(() => [_createVNode(_component_el_button, {
                  onClick: generateToken
                }, {
                  default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode("生成Token")])),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "启用状态"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: item.value.enabled,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => item.value.enabled = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue", "title"])])), [[_directive_loading, loading.value]]);
    };
  }
};